import {
    UPDATE_CALL_STATUS_START,
    UPDATE_CALL_STATUS_SUCCESS,
    UPDATE_CALL_STATUS_FAILURE,
    MARK_CALL_RECEIVED_START,
    MARK_CALL_RECEIVED_SUCCESS,
    MARK_CALL_RECEIVED_FAILURE,
  } from "../types/callActionTypes";
  
  import { updateCallStatus,markCallReceived } from "../../services/CallService";
  import {
    handleSuccess,
    showErrorAlert,
  } from "../../services/ErrorHandlingService";
  
  
  // =======================
  // Update Call Status
  // =======================
  export function updateCallStatusAction(payload) {
    return async (dispatch) => {
      try {
        dispatch({ type: UPDATE_CALL_STATUS_START });
  
        const response = await updateCallStatus(payload);
  
        if (response?.status === 200) {
          dispatch({
            type: UPDATE_CALL_STATUS_SUCCESS,
            payload: response.data,
          });
  
          handleSuccess("Call status updated successfully!");
        }
      } catch (error) {
        console.error("Update call status error:", error);
  
        dispatch({
          type: UPDATE_CALL_STATUS_FAILURE,
          payload: error?.response?.data || error.message,
        });
  
        showErrorAlert("Failed to update call status");
      }
    };
  }
  
  export const markCallReceivedAction = (payload) => {
    return async (dispatch) => {
      try {
        dispatch({ type: MARK_CALL_RECEIVED_START });
  
        const response = await markCallReceived(payload);
  
        if (response?.status === 200) {
          dispatch({
            type: MARK_CALL_RECEIVED_SUCCESS,
            payload: response.data,
          });
  
          handleSuccess("Call marked as received!");
        }
      } catch (error) {
        console.error("Mark call received error:", error);
  
        dispatch({
          type: MARK_CALL_RECEIVED_FAILURE,
          payload: error?.response?.data || error.message,
        });
  
        showErrorAlert("Failed to mark call as received");
      }
    };
  };